import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Chip, Tab, Tabs } from '@mui/material';
import { CURRENT_WINDOW_DAYS } from '../../../store/utils/shipmentUtils';
import { navigateToPreset } from '../../../store/thunks/shipmentModuleThunks';

// eslint-disable-next-line react/prop-types
const TabLabel = ({ label, count, loading }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
    {label}
    <Chip
      label={loading ? '...' : count}
      size='small'
      sx={{
        height: 18,
        fontSize: '0.7rem',
        minWidth: 24,
        '& .MuiChip-label': { px: 0.5 },
      }}
    />
  </Box>
);

const ShipmentPresetTabs = () => {
  const dispatch = useDispatch();
  const { activePreset, presetCounts } = useSelector(({ shipmentModule }) => shipmentModule);

  const handleChange = (event, newValue) => {
    dispatch(navigateToPreset({ preset: newValue }));
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
      <Tabs
        value={activePreset}
        onChange={handleChange}
        sx={{
          minHeight: 36,
          '& .MuiTab-root': { minHeight: 36, py: 0, textTransform: 'none' },
        }}
      >
        <Tab
          label={<TabLabel label='All' count={presetCounts.all} loading={presetCounts.loading} />}
          value='all'
        />
        <Tab
          label={
            <TabLabel
              label={`Last ${CURRENT_WINDOW_DAYS}d`}
              count={presetCounts.current}
              loading={presetCounts.loading}
            />
          }
          value='current'
        />
        <Tab
          label={
            <TabLabel
              label='Bad Addresses'
              count={presetCounts.badAddresses}
              loading={presetCounts.loading}
            />
          }
          value='badAddresses'
        />
        <Tab
          label={
            <TabLabel label='Manual' count={presetCounts.manual} loading={presetCounts.loading} />
          }
          value='manual'
        />
      </Tabs>
    </Box>
  );
};

export default ShipmentPresetTabs;
